<!-- Copyright (c) 2023 Digital Systems (M) Sdn. Bhd. -->

<template>
  <div class="container-type-main">
    <div>
      <Menus :menu="menu" icon="https://dsmlib.logistics.systems/Icons/ContainerType.png" @menuClicked="menuClicked" />
    </div>
    <div class="container-type-table">
      <TableBox
        :tableData="ContainerCategoryList"
        :selectedRow.sync="selectedArea"
        title="Container Type"
        :dataType="columnTypeMain"
      />
    </div>
    <PopupEntry
      :show.sync="popupEntryShow"
      v-if="popupEntryShow"
      :title="popupEntryTitle"
      :updatedBy="updatedBy"
      :createdBy="createdBy"
      @save="saveClicked"
      :requiredError="entryRequired"
      :successMessages="entrySuccess"
      :messages="entryMessages"
      :errorMessages="entryError"
      @requiredClicked="entryRequiredClicked"
      :viewMode="viewMode"
      :cancelButton="viewMode ? 'Close' : 'Cancel'"
    >
      <div class="General Details" style="display: flex; height: 100%">
        <!-- General Details -->
        <div class="gen-details-right" placeholder="Container">
          <!-- ContType -->
          <Input
            validator="alphanumeric,5"
            :isDisabled="viewModePK"
            :isRequired="true"
            placeholder="Container Type (max. 5 characters)"
            :inputValue.sync="contType"
            :errorMessage.sync="contTypeError"
            ref="category_contType"
          />
          <!-- ContTypeDescription -->
          <Input
            :isDisabled="viewMode"
            placeholder="Container Type Description (max. 50 characters)"
            :inputValue.sync="description"
            :errorMessage.sync="descriptionError"
            ref="category_description"
          />

          <div style="display: flex; flex-direction: row">
            <BoxContainer title="20 FT" class="container-type-size">
              <!-- Height -->
              <Input
                validator="positiveDecimal,3,4"
                :isDisabled="viewMode"
                placeholder="Height (M)"
                :inputValue.sync="height"
                :errorMessage.sync="heightError"
                ref="category_height"
              />
              <!-- Width -->
              <Input
                validator="positiveDecimal,3,4"
                :isDisabled="viewMode"
                placeholder="Width (M)"
                :inputValue.sync="width"
                :errorMessage.sync="widthError"
                ref="category_width"
              />
              <!-- Length -->
              <Input
                validator="positiveDecimal,3,4"
                :isDisabled="viewMode"
                placeholder="Length (M)"
                :inputValue.sync="length20"
                :errorMessage.sync="length20Error"
                ref="category_length"
              />
              <!-- Measurement -->
              <Input
                validator="positiveDecimal,3,4"
                :isDisabled="viewMode"
                placeholder="Measurement  (M3)"
                :inputValue.sync="measurement20"
                :errorMessage.sync="measurement20Error"
                ref="category_measurement"
              />
              <!-- Weight -->
              <Input
                validator="positiveDecimal,3,4"
                :isDisabled="viewMode"
                placeholder="Weight (KG)"
                :inputValue.sync="weight20"
                :errorMessage.sync="weight20Error"
                ref="category_weight"
              />
              <!-- ISOCode -->
              <Input
                validator="alphanumeric,5"
                :isDisabled="viewMode"
                placeholder="ISO Code"
                :inputValue.sync="isoCode20"
                :errorMessage.sync="isoCode20Error"
                ref="category_isoCode"
              />
            </BoxContainer>
            <BoxContainer title="40 FT" class="container-type-size">
              <!-- Height -->
              <Input
                validator="positiveDecimal,3,4"
                :isDisabled="viewMode"
                placeholder="Height (M)"
                :inputValue.sync="height"
                :errorMessage.sync="heightError"
                ref="category_height"
              />
              <!-- Width -->
              <Input
                validator="positiveDecimal,3,4"
                :isDisabled="viewMode"
                placeholder="Width (M)"
                :inputValue.sync="width"
                :errorMessage.sync="widthError"
                ref="category_width"
              />
              <!-- Length -->
              <Input
                validator="positiveDecimal,3,4"
                :isDisabled="viewMode"
                placeholder="Length (M)"
                :inputValue.sync="length40"
                :errorMessage.sync="length40Error"
                ref="category_length"
              />
              <!-- Measurement -->
              <Input
                validator="positiveDecimal,3,4"
                :isDisabled="viewMode"
                placeholder="Measurement  (M3)"
                :inputValue.sync="measurement40"
                :errorMessage.sync="measurement40Error"
                ref="category_measurement"
              />
              <!-- Weight -->
              <Input
                validator="positiveDecimal,3,4"
                :isDisabled="viewMode"
                placeholder="Weight (KG)"
                :inputValue.sync="weight40"
                :errorMessage.sync="weight40Error"
                ref="category_weight"
              />
              <!-- ISOCode -->
              <Input
                validator="alphanumeric,5"
                :isDisabled="viewMode"
                placeholder="ISO Code"
                :inputValue.sync="isoCode40"
                :errorMessage.sync="isoCode40Error"
                ref="category_isoCode"
              />
            </BoxContainer>
            <BoxContainer title="45 FT" class="container-type-size">
              <!-- Height -->
              <Input
                validator="positiveDecimal,3,4"
                :isDisabled="viewMode"
                placeholder="Height (M)"
                :inputValue.sync="height"
                :errorMessage.sync="heightError"
                ref="category_height"
              />
              <!-- Width -->
              <Input
                validator="positiveDecimal,3,4"
                :isDisabled="viewMode"
                placeholder="Width (M)"
                :inputValue.sync="width"
                :errorMessage.sync="widthError"
                ref="category_width"
              />
              <!-- Length -->
              <Input
                validator="positiveDecimal,3,4"
                :isDisabled="viewMode"
                placeholder="Length (M)"
                :inputValue.sync="length45"
                :errorMessage.sync="length45Error"
                ref="category_length"
              />
              <!-- Measurement -->
              <Input
                validator="positiveDecimal,3,4"
                :isDisabled="viewMode"
                placeholder="Measurement  (M3)"
                :inputValue.sync="measurement45"
                :errorMessage.sync="measurement45Error"
                ref="category_measurement"
              />
              <!-- Weight -->
              <Input
                validator="positiveDecimal,3,4"
                :isDisabled="viewMode"
                placeholder="Weight (KG)"
                :inputValue.sync="weight45"
                :errorMessage.sync="weight45Error"
                ref="category_weight"
              />
              <!-- ISOCode -->
              <Input
                validator="alphanumeric,5"
                :isDisabled="viewMode"
                placeholder="ISO Code"
                :inputValue.sync="isoCode45"
                :errorMessage.sync="isoCode45Error"
                ref="category_isoCode"
              />
            </BoxContainer>
          </div>
          <!-- DemurrageDays -->
          <Input
            validator="positiveInteger,2"
            :isDisabled="viewMode"
            placeholder="Demurrage Days"
            :inputValue.sync="demurrageDays"
            :errorMessage.sync="demurrageDaysError"
            ref="category_demurrageDays"
          />
          <!-- WebView -->
          <Dropdown
            :isDisabled="viewMode"
            placeholder="WebView"
            :selectedObject.sync="webview"
            :search.sync="webviewSearch"
            :items="optionsForWebview"
            itemKey="label"
            :errorMessage.sync="webviewError"
            style="padding-bottom: 30px"
            ref="category_webview"
          />
        </div>
      </div>
    </PopupEntry>
  </div>
</template>
<script>
export default {
  components: {},
  computed: {},
  data: function () {
    return {
      menu: [
        {
          title: 'New Container Type',
          icon: 'https://dsmapi.logistics.systems/dsm6gicons/icons8-add-new-50.png',
          key: 'MnuNew',
          visible: true,
          enabled: true,
        },
        {
          title: 'Edit Container Type',
          icon: 'https://dsmapi.logistics.systems/dsm6gicons/icons8-edit-64%20(1).png',
          key: 'MnuEdit',
          visible: true,
          enabled: true,
        },
        {
          title: 'Delete Container Type',
          icon: 'https://dsmapi.logistics.systems/dsm6gicons/icons8-reduce-50.png',
          key: 'MnuDelete',
          visible: false,
          enabled: true,
        }, //api response logic abit weird ("Hide Delete" instead of "Delete")
        {
          title: 'View Container Type',
          icon: 'https://dsmapi.logistics.systems/dsm6gicons/icons8-view-64.png',
          key: 'MnuQuery',
          visible: true,
          enabled: true,
        },
      ],
      ContainerCategoryList: [],
      viewMode: false,
      viewModePK: false,
      popupEntryShow: false,
      menuType: '',
      contType: '',
      contTypeError: '',
      description: '',
      descriptionError: '',
      height: '',
      heightError: '',
      width: '',
      widthError: '',

      // container size 20ft
      length20: '',
      length20Error: '',
      measurement20: '',
      measurement20Error: '',
      weight20: '',
      weight20Error: '',
      isoCode20: '',
      isoCode20Error: '',

      // container size 40ft
      length40: '',
      length40Error: '',
      measurement40: '',
      measurement40Error: '',
      weight40: '',
      weight40Error: '',
      isoCode40: '',
      isoCode40Error: '',

      // container size 45ft
      length45: '',
      length45Error: '',
      measurement45: '',
      measurement45Error: '',
      weight45: '',
      weight45Error: '',
      isoCode45: '',
      isoCode45Error: '',

      webview: null,
      webviewError: '',
      webviewSearch: '',
      demurrageDays: '',
      demurrageDaysError: '',

      entryRequired: [],
      entrySuccess: [],
      entryMessages: [],
      entryError: [],
      selectedArea: [],
      selectedOriginalArea: null,

      optionsForWebview: [
        { label: 'Yes', API_Value: '1' },
        { label: 'No', API_Value: '0' },
      ],
      columnTypeMain: {
        '#': 'number',
        'Cont Type': 'string',
        'Cont Desc': 'string',
        Height: 'number',
        Width: 'number',
        'Demurrage Days': 'nunber',
        'Web View': 'number',
      },
    };
  },
  props: {},
  methods: {
    entryRequiredClicked: function (item) {
      this.$nextTick(() => {
        this.$refs[item].setFocus();
      });
    },
    getContainerCategoryList: async function () {
      this.ContainerCategoryList = [];
      this.$fullscreenLoading('Getting Container Category List');
      this.ContainerCategoryList = await this.$apiCallV2('/Master/GetListMaster', { masterfile: 'conttype' });
      this.$fullscreenLoading();
    },

    menuClicked: async function (e) {
      this.clearEntryMessages();
      this.clearAllFields();
      switch (e.title) {
        case 'New Container Type':
          this.clearAllFields();
          this.viewMode = false;
          this.viewModePK = false;
          this.popupEntryShow = true;
          this.descriptionInputIsDisabled = true;
          this.popupEntryTitle = 'New Container Type';
          this.updatedBy = '';
          this.createdBy = '';
          this.menuType = 'New';
          break;
        case 'Edit Container Type':
          if (this.selectedArea.length == 0) {
            this.$showAlert('error', 'No container is selected', 'Please select a container to edit');
          } else {
            this.viewMode = false;
            this.viewModePK = true;
            this.popupEntryShow = true;
            this.descriptionInputIsDisabled = false;
            this.popupEntryTitle = 'Edit Container Type';
            this.selectedOriginalArea = JSON.parse(JSON.stringify(this.selectedArea[0]));
            await this.populateViewDetails(this.selectedArea[0]['Cont Type']);
          }
          break;
        case 'Delete Container Type':
          if (this.selectedArea.length == 0) {
            this.$showAlert('error', 'No container is selected', 'Please select a container to delete');
          } else {
            const deleting = await this.$showAlert(
              'warning',
              'Delete Container',
              `Are you sure you want to delete Container for <b>${this.selectedArea[0]['Cont Type']}<b>?`,
              [
                { text: 'Delete', textColor: 'white', color: 'red' },
                { text: 'Cancel', textColor: 'black', color: 'lightgray' },
              ],
            );
            if (deleting == 'Delete') {
              const result = await this.$apiCallV2('/ContainerType/SaveContType', {
                action: 'D',
                conttype: this.selectedArea[0]['Cont Type'],
              });
              if (result[0]['Results'] == 0) {
                // Delete successful
                this.$showAlert(
                  'success',
                  'Container Deleted',
                  `Successfully deleted Container for ${this.selectedArea[0]['Cont Type']}`,
                );
                this.$nextTick(async () => await this.getContainerCategoryList());
              } else {
                // Delete error
                this.$showAlert(
                  'error',
                  'Container NOT Deleted',
                  `There was an error deleting Container for ${this.selectedArea[0]['Cont Type']}`,
                );
              }
            }
          }
          this.selectedArea = [];
          break;
        case 'View Container Type':
          if (this.selectedArea.length == 0) {
            this.$showAlert('error', 'No container is selected', 'Please select a container to view');
          } else {
            this.viewMode = true;
            this.popupEntryShow = true;
            this.viewModePK = true;
            this.popupEntryTitle = 'View Container Type Details';
            await this.populateViewDetails(this.selectedArea[0]['Cont Type']);
          }
          break;
      }
    },
    clearAllFields: function () {
      this.contType = '';
      this.contTypeError = '';
      this.description = '';
      this.descriptionError = '';
      this.height = '';
      this.heightError = '';
      this.width = '';
      this.widthError = '';

      // container size 20ft
      this.length20 = '';
      this.length20Error = '';
      this.measurement20 = '';
      this.measurement20Error = '';
      this.weight20 = '';
      this.weight20Error = '';
      this.isoCode20 = '';
      this.isoCode20Error = '';

      // container size 40ft
      this.length40 = '';
      this.length40Error = '';
      this.measurement40 = '';
      this.measurement40Error = '';
      this.weight40 = '';
      this.weight40Error = '';
      this.isoCode40 = '';
      this.isoCode40Error = '';

      // container size 45ft
      this.length45 = '';
      this.length45Error = '';
      this.measurement45 = '';
      this.measurement45Error = '';
      this.weight45 = '';
      this.weight45Error = '';
      this.isoCode45 = '';
      this.isoCode45Error = '';

      this.demurrageDays = '';
      this.demurrageDaysError = '';
      this.webview = null;
      this.webviewSearch = '';
      this.menuType = '';
      this.createdBy = '';
      this.updatedBy = '';
    },

    checkFields: function () {
      this.clearEntryMessages();
      const numInputError = ' must be a number!';
      const numLengthError = ' cannot exceed 3 whole digits and 4 decimals!';

      // Container Type validation
      if (this.contType.length > 5) {
        this.contTypeError = 'Container Type cannot exceed 5 characters!';
        this.entryRequired.push({ key: 'category_contType', value: 'Container Type cannot exceed 5 characters!' });
      } else if (this.contType === '') {
        this.contTypeError = 'Container type is required!';
        this.entryRequired.push({ key: 'category_contType', value: 'Container type is required!' });
      }

      // Description validation
      if (this.description.length > 50) {
        this.descriptionError = 'Container Description cannot exceed 50 characters!';
        this.entryRequired.push({
          key: 'category_description',
          value: "Container Description cannot exceed 50 characters!",
        });
      }

      // Height validation
      if (!this.height.match(/^\d*\.?\d*$/g)) {
        this.heightError = numInputError;
        this.entryRequired.push({ key: 'category_height', value: 'Height' + numInputError });
      } else if (this.height.split('.')[0].length > 3 || (this.height.includes('.') && this.height.split('.')[1]?.length > 4)) {
        this.heightError = 'Height' + numLengthError;
        this.entryRequired.push({ key: 'category_height', value: 'Height' + numLengthError});
      }

      // Width validation
      if (!this.width.match(/^\d*\.?\d*$/g)) {
        this.widthError = numInputError;
        this.entryRequired.push({ key: 'category_width', value: 'Width' + numInputError });
      } else if (this.width.split('.')[0].length > 3 || (this.width.includes('.') && this.width.split('.')[1]?.length > 4)) {
        this.widthError = 'Width' + numLengthError;
        this.entryRequired.push({ key: 'category_width', value: 'Width' + numLengthError });
      }

      // Container size 20 validation
      if (!this.length20.match(/^\d*\.?\d*$/g)) {
        this.length20Error = numInputError;
        this.entryRequired.push({ key: 'category_length', value: 'Length (20 ft)' + numInputError });
      } else if (this.length20.split('.')[0].length > 3 || (this.length20.includes('.') && this.length20.split('.')[1]?.length > 4)) {
        this.length20Error = 'Length (20 ft)' + numLengthError;
        this.entryRequired.push({ key: 'category_length', value: 'Length (20 ft)' + numLengthError });
      }

      if (!this.measurement20.match(/^\d*\.?\d*$/g)) {
        this.measurement20Error = numInputError;
        this.entryRequired.push({ key: 'category_measurement', value: 'Measurement (20 ft)' + numInputError });
      } else if (this.measurement20.split('.')[0].length > 3 || (this.measurement20.includes('.') && this.measurement20.split('.')[1]?.length > 4)) {
        this.measurement20Error = 'Measurement (20 ft)' + numLengthError;
        this.entryRequired.push({ key: 'category_measurement', value: 'Measurement (20 ft)' + numLengthError});
      }

      if (!this.weight20.match(/^\d*\.?\d*$/g)) {
        this.weight20Error = numInputError;
        this.entryRequired.push({ key: 'category_weight', value: 'Weight (20 ft)' + numInputError });
      } else if (this.weight20.split('.')[0].length > 3 || (this.weight20.includes('.') && this.weight20.split('.')[1]?.length > 4)) {
        this.weight20Error = 'Weight (20 ft)' + numLengthError;
        this.entryRequired.push({ key: 'category_weight', value: 'Weight (20 ft)' + numLengthError});
      }

      // Container size 40 validation
      if (!this.length40.match(/^\d*\.?\d*$/g)) {
        this.length40Error = numInputError;
        this.entryRequired.push({ key: 'category_length', value: 'Length (40 ft)' + numInputError });
      } else if (this.length40.split('.')[0].length > 3 || (this.length40.includes('.') && this.length40.split('.')[1]?.length > 4)) {
        this.length40Error = 'Length (40 ft)' + numLengthError;
        this.entryRequired.push({ key: 'category_length', value: 'Length (40 ft)' + numLengthError});
      }

      if (!this.measurement40.match(/^\d*\.?\d*$/g)) {
        this.measurement40Error = numInputError;
        this.entryRequired.push({ key: 'category_measurement', value: 'Measurement (40 ft' +  numInputError });
      } else if (this.measurement40.split('.')[0].length > 3 || (this.measurement40.includes('.') && this.measurement40.split('.')[1]?.length > 4)) {
        this.measurement40Error = 'Measurement (40 ft)' + numLengthError;
        this.entryRequired.push({ key: 'category_measurement', value: 'Measurement (40 ft)' + numLengthError});
      }

      if (!this.weight40.match(/^\d*\.?\d*$/g)) {
        this.weight40Error = numInputError;
        this.entryRequired.push({ key: 'category_weight', value: 'Weight (40 ft)' +  numInputError });
      } else if (this.weight40.split('.')[0].length > 3 || (this.weight40.includes('.') && this.weight40.split('.')[1]?.length > 4)) {
        this.weight40Error = 'Weight (40 ft)' + numLengthError;
        this.entryRequired.push({ key: 'category_weight', value: 'Weight (40 ft)' + numLengthError});
      }

      // Container size 45 validation
      if (!this.length45.match(/^\d*\.?\d*$/g)) {
        this.length45Error = numInputError;
        this.entryRequired.push({ key: 'category_length', value: 'Length (45 ft)' +  numInputError });
      } else if (this.length45.split('.')[0].length > 3 || (this.length45.includes('.') && this.length45.split('.')[1]?.length > 4)) {
        this.length45Error = 'Length (45 ft)' + numLengthError;
        this.entryRequired.push({ key: 'category_length', value: 'Length (45 ft)' + numLengthError});
      }

      if (!this.measurement45.match(/^\d*\.?\d*$/g)) {
        this.measurement45Error = numInputError;
        this.entryRequired.push({ key: 'category_measurement', value: 'Measurement (45 ft)' +  numInputError });
      } else if (this.measurement45.split('.')[0].length > 3 || (this.measurement45.includes('.') && this.measurement45.split('.')[1]?.length > 4)) {
        this.measurement45Error = 'Measurement (45 ft)' + numLengthError;
        this.entryRequired.push({ key: 'category_measurement', value: 'Measurement (45 ft)' + numLengthError});
      }

      if (!this.weight45.match(/^\d*\.?\d*$/g)) {
        this.weight45Error = numInputError;
        this.entryRequired.push({ key: 'category_weight', value: 'Weight (45 ft)' +  numInputError });
      } else if (this.weight45.split('.')[0].length > 3 || (this.weight45.includes('.') && this.weight45.split('.')[1]?.length > 4)) {
        this.weight45Error = 'Weight (45 ft)' + numLengthError;
        this.entryRequired.push({ key: 'category_weight', value: 'Weight (45 ft)' + numLengthError});
      }

      // ISO Code validations
      if (this.isoCode20.length > 5) {
        this.isoCode20Error = 'ISO Code (20 ft) cannot exceed 5 characters!';
        this.entryRequired.push({ key: 'category_isoCode', value: 'ISO Code (20 ft) cannot exceed 5 characters!' });
      }
      if (this.isoCode40.length > 5) {
        this.isoCode40Error = 'ISO Code (40 ft) cannot exceed 5 characters!';
        this.entryRequired.push({ key: 'category_isoCode', value: 'ISO Code (40 ft) cannot exceed 5 characters!' });
      }
      if (this.isoCode45.length > 5) {
        this.isoCode45Error = 'ISO Code (45 ft) cannot exceed 5 characters!';
        this.entryRequired.push({ key: 'category_isoCode', value: 'ISO Code (45 ft) cannot exceed 5 characters!' });
      }

      // Demurrage Days validation
      if (this.demurrageDays.length > 2) {
        this.demurrageDaysError = 'Demurrage Days cannot exceed 2 digits!';
        this.entryRequired.push({ key: 'category_demurrageDays', value: 'Demurrage Days cannot exceed 2 digits!' });
      }

      return this.entryRequired.length > 0;
    },

    clearEntryMessages: function () {
      this.entryRequired = [];
      this.entrySuccess = [];
      this.entryMessages = [];
      this.entryError = [];
    },
    populateTextTrim: function (text) {
      // To populate text with trim
      return text ? text.trim() : '';
    },
    saveClicked: async function () {
      const isNotValid = this.checkFields();
      if (!isNotValid) {
        const action = this.popupEntryTitle[0];
        if (action == 'E') {
          if (this.selectedOriginalArea['ContTypeDesc'] != this.description) {
            const change = await this.$showAlert(
              'warning',
              'Edit Container',
              `Are you sure you want to save the data that you had made changes to Container Type: "<b>${this.contType}</b>"`,
              [
                { text: 'Confirm', textColor: 'white', color: 'red' },
                { text: 'Cancel', textColor: 'black', color: 'lightgray' },
              ],
            );
            if (change == 'Cancel') {
              return;
            }
          }
        }
        const dataToPost = {
          conttype: this.contType.toUpperCase(),
          conttypedesc: this.description,
          action: action, //actionflag
          height: this.height,
          width: this.width,
          //container size 20 ft
          length20: this.length20,
          measurement20: this.measurement20,
          weight20: this.weight20,
          isocode20: this.isoCode20,
          // Container size 40 ft
          length40: this.length40,
          measurement40: this.measurement40,
          weight40: this.weight40,
          isocode40: this.isoCode40,
          // Container size 45 ft
          length45: this.length45,
          measurement45: this.measurement45,
          weight45: this.weight45,
          isocode45: this.isoCode45,
          demurragedays: this.demurrageDays,
          webview: this.webview && this.webview.API_Value ? this.webview.API_Value : '',
        };
        this.$fullscreenLoading(dataToPost['Action'] == 'D' ? 'Deleting Container Type' : 'Saving Container Type');
        const result = await this.$apiCallV2('/ContainerType/SaveContType', dataToPost);
        this.$nextTick(async () => await this.getContainerCategoryList());
        this.$fullscreenLoading();
        if (result[0]['Results'] == 0) {
          // Save successful
          if (action == 'N') {
            this.entrySuccess.push(`Successfully created Container Type: ${this.contType}`);
          } else {
            this.entrySuccess.push(`Successfully edited Container Type: ${this.contType}`);
          }
          this.viewMode = true;
          this.viewModePK = true;
        } else if (action == 'N') {
          // Save error - N
          this.entryError.push(`There was an error creating Container Type: ${result[0]['ErrMsg']}`);
        } else {
          //Save error - E
          this.entryError.push(`There was an error editing Container Type: ${result[0]['ErrMsg']}`);
        }
      }
    },
    populateViewDetails: async function (contTypeSelected) {
      this.$fullscreenLoading('Getting Details');
      const details = (
        await this.$apiCallV2('/Master/GetDetailsMaster', {
          masterfile: 'CONTTYPE',
          module: 'MASTER',
          recordid: contTypeSelected,
        })
      )['ContainerType'];
      this.contType = this.populateTextTrim(details['ContType']);
      this.description = this.populateTextTrim(details['ContTypeDesc']);
      this.height = this.populateTextTrim(details['Height']);
      this.width = this.populateTextTrim(details['Width']);
      this.length20 = this.populateTextTrim(details['Length20']);
      this.measurement20 = this.populateTextTrim(details['Measurement20']);
      this.weight20 = this.populateTextTrim(details['Weight20']);
      this.isoCode20 = this.populateTextTrim(details['ISOCode20']);
      this.length40 = this.populateTextTrim(details['Length40']);
      this.measurement40 = this.populateTextTrim(details['Measurement40']);
      this.weight40 = this.populateTextTrim(details['Weight40']);
      this.isoCode40 = this.populateTextTrim(details['ISOCode40']);
      this.length45 = this.populateTextTrim(details['Length45']);
      this.measurement45 = this.populateTextTrim(details['Measurement45']);
      this.weight45 = this.populateTextTrim(details['Weight45']);
      this.isoCode45 = this.populateTextTrim(details['ISOCode45']);
      this.demurrageDays = this.populateTextTrim(details['DemurrageDays']);
      this.webview = this.populateObject(this.optionsForWebview, 'API_Value', details['WebView'] || '0');
      this.updatedBy = `${details['UserID'].trim() ? details['UserID'].trim() : ''} ${details['DateUpdated'] ? this.$dateTime.getDateTime(new Date(details['DateUpdated']), 'dd/MM/yyyy HH:mm') : ''}`;
      this.createdBy = `${details['UserCreated'] || ''} ${details['TimeCreated'] ? this.$dateTime.getDateTime(new Date(details['TimeCreated']), 'dd/MM/yyyy HH:mm') : ''}`;
      this.$fullscreenLoading();
    },
    populateObject: function (data, key, compare) {
      // To populate object into dropdown or input query
      try {
        return data.find((d) => d[key].trim() == (compare ? compare.trim() : ''));
      } catch (error) {
        return null;
      }
    },
  },
  async mounted() {
    this.$bus.$on('pageSASControlAccess', (x) => {
      if (x.page == 'Container Type') {
        x.data.forEach((k) => {
          //key in menu same as control value from api
          const selectedMenu = this.menu.find((m) => m['key'] == k['Control']);
          if (selectedMenu) {
            selectedMenu[k['Properties'].toLowerCase()] = k['PropertiesValue'] == 'True';
          }
        });
      }
    });
    this.$fullscreenLoading('Getting Container Type');
    this.ContainerCategoryList = await this.$apiCallV2('/Master/GetListMaster', { masterfile: 'conttype' });

    this.$fullscreenLoading();
  },
  watch: {},
};
</script>
<style lang="scss" scoped>
@import '@/css/all.scss';

.container-type-main {
  font-size: 12px;
  width: 100%;
  height: 100%;
  padding: 10px 45px;
  display: flex;
  .container-type-table {
    width: 100%;
    margin-left: 5px;
    padding: 5px;
    background-color: white;
    border-radius: 5px;
    display: flex;
    overflow: hidden;
  }
  .gen-details-right {
    display: flex;
    flex-direction: column;
    width: 100%;
  }

  .container-type-size {
    display: flex;
    flex-direction: column;
    flex: 1;
    margin: 10px;
  }
}
</style>
